import React, { useEffect, useLayoutEffect, useState } from "react";
import styled from "styled-components";
import { graphql, Link, useStaticQuery } from "gatsby";
import { CartProvider } from "../context/cart-context";
import { GlobalStyle } from "../styles/global";
import PageHeader from "./header";
import { useSettings } from "../hooks/useSettings";
import { Breadcrumb } from "gatsby-plugin-breadcrumb";
import BreadcrumbContainer from "./BreadcrumbContainer";

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const BreadcrumbWrapper = styled.div`
  background-color: var(--background-light);
  border-bottom: 1px solid var(--border-color);
`;

const Main = styled.main`
  flex: 1;
  width: 100%;
`;

const Footer = styled.footer`
  background: var(--background);
  color: var(--text-color);
  padding: 3rem 0 2rem;
  margin-top: auto;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
  text-align: center;
  
  @media (min-width: 768px) {
    padding: 0 2rem;
  }
`;

const FooterText = styled.p`
  margin: 0;
  opacity: 0.8;
  font-size: 0.9rem;
  color: var(--text-light);
`;

interface LayoutProps {
  pageContext: any;
  children: React.ReactNode;
}

interface Breadcrumb {
  label: string;
  path: string;
}

const Layout: React.FC<LayoutProps> = ({ pageContext, children }) => {
  console.log(pageContext);

  const { breadcrumb } = pageContext;

  const { author } = useSettings();

  return (
    <CartProvider>
      <GlobalStyle />
      <Container>
        <PageHeader />
        { breadcrumb && <BreadcrumbWrapper>
          <div className="container">
            <BreadcrumbContainer breadcrumbs={breadcrumb} />
          </div>
        </BreadcrumbWrapper>}

        <Main>{children}</Main>

        <Footer>
          <FooterContent>
            <FooterText>
              © {new Date().getFullYear()} {author}. All rights reserved.
            </FooterText>
          </FooterContent>
        </Footer>
      </Container>
    </CartProvider>
  );
};

export default Layout;
